import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { formatMoney } from 'helpers/helpers'
import { httpOk, GET } from 'helpers/api'

function Index({
	modalPartner,
	selectedItem,
	toggleModalPartner,
}) {
	const { t } = useTranslation()
	const [selectedItemPartners, setSelectedItemPartners] = useState([])

	async function getData() {
		const response = await GET(`/partner/pos/${selectedItem.id}/partners`, {}, { loader: true })
		if (httpOk(response)) setSelectedItemPartners(response.data)
	}

	useEffect(() => {
		if (modalPartner) getData()
	}, [modalPartner]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{/* MODAL PARTNER*/}
			<Modal show={modalPartner} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalPartner()}>
				<Modal.Header closeButton>
					<Modal.Title>{t('partners')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'width': '70%' }}>{t('partner')}</th>
									<th style={{ 'width': '30%' }} className="text-end">{t('percentage')}</th>
								</tr>
							</thead>
							<tbody>
								{selectedItemPartners?.length > 0 ?
									selectedItemPartners.map((item, index) => (
										<tr key={item.id ?? index}>
											<td>{item.name || '—'}</td>
											<td className="text-end">{formatMoney(item.partner_percentage)}%</td>
										</tr>
									))
									:
									<tr>
										<td colSpan={2} className="text-center text-muted">{t('list_empty')}</td>
									</tr>
								}
							</tbody>
						</table>
					</div>

					<button type="button" className="btn btn-outline-warning w-100 mt-3"
						onClick={() => toggleModalPartner()}>
						{t('cancel')}
					</button>
				</Modal.Body>
			</Modal>
			{/* MODAL PARTNER*/}
		</>
	)
}

export default Index
